module.exports = __webpack_public_path__ + "img/consult_hedaer.7cf48a4f.png";